export function formatFieldName(field = "") {
  if (!field) return "";

  let f = field;

  // Remove patterns
  f = f.replace(/_?ID$/i, "");           // remove trailing ID or _ID
  f = f.replace(/TEMPORARY/gi, "");
  f = f.replace(/HEADER/gi, "");
  f = f.replace(/\bCP\b/gi, "");         // remove standalone CP

  // Underscore to space
  f = f.replace(/_/g, " ");

  // Cleanup extra spaces
  f = f.replace(/\s+/g, " ").trim();

  // Capitalize each word
  f = f.toLowerCase().replace(/\b[a-z]/g, (m) => m.toUpperCase());

  return f;
}
